import "antd/es/row/style";
import _Row from "antd/es/row";
import "antd/es/col/style";
import _Col from "antd/es/col";
var _excluded = ["parentName", "name", "label", "labelProps", "contentProps", "style", "preview", "disabledFromParent", "setShowStepButton", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useMemo, useReducer, useEffect, cloneElement, isValidElement } from 'react';
import FormContext from '../../form-context';
import { calcNamePath, calcFormItemProps } from '../../utils/form-utils';
import Typography from '../../typography';
import './style/index.less';

var Section = function Section(props) {
  var _useContext = useContext(FormContext),
      form = _useContext.form,
      requiredMark = _useContext.requiredMark,
      registerDependencies = _useContext.registerDependencies;

  var _useReducer = useReducer(function (r) {
    return r + 1;
  }, 0),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      _ = _useReducer2[0],
      dispatch = _useReducer2[1];

  var parentName = props.parentName,
      name = props.name,
      label = props.label,
      _props$labelProps = props.labelProps,
      labelProps = _props$labelProps === void 0 ? {} : _props$labelProps,
      _props$contentProps = props.contentProps,
      contentProps = _props$contentProps === void 0 ? {} : _props$contentProps,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style,
      preview = props.preview,
      disabledFromParent = props.disabledFromParent,
      setShowStepButton = props.setShowStepButton,
      children = props.children,
      rest = _objectWithoutProperties(props, _excluded);

  var namePath = useMemo(function () {
    return calcNamePath(parentName, name);
  }, [parentName, name]);
  useEffect(function () {
    var dependencies = props.dependencies,
        asserts = props.asserts,
        copyValue = props.copyValue,
        selectValue = props.selectValue,
        shouldRender = props.shouldRender,
        subscribedFields = props.subscribedFields,
        disabled = props.disabled;
    var dependentField = dependencies || [];

    if (Array.isArray(subscribedFields)) {
      dependentField.push.apply(dependentField, _toConsumableArray(subscribedFields));
    }

    if (asserts && asserts.length) {
      asserts.forEach(function (_ref) {
        var field = _ref.field;
        return dependentField.push(field);
      });
    }

    if (copyValue) {
      dependentField.push(copyValue.assert.field);
    }

    if (selectValue && selectValue.length) {
      selectValue.forEach(function (_ref2) {
        var assert = _ref2.assert;
        return dependentField.push(assert.field);
      });
    }

    if (shouldRender && !Array.isArray(subscribedFields)) {
      dependentField.push('SUBSCRIBE_ALL');
    }

    if (Array.isArray(disabled)) {
      disabled.forEach(function (_ref3) {
        var field = _ref3.field;
        return dependentField.push(field);
      });
    } else if (_typeof(disabled) === 'object') {
      dependentField.push(disabled.field);
    }

    registerDependencies(dependentField, dispatch);
  }, []);

  var _calcFormItemProps = calcFormItemProps(rest, {
    requiredMark: requiredMark
  }, form, parentName),
      formItemProps = _calcFormItemProps.formItemProps,
      elementProps = _calcFormItemProps.elementProps,
      display = _calcFormItemProps.display;

  if (formItemProps.copiedValue.copied) {
    var currentValue = form === null || form === void 0 ? void 0 : form.getFieldValue(namePath);

    var value = _objectSpread(_objectSpread({}, currentValue), formItemProps.copiedValue.value);

    form === null || form === void 0 ? void 0 : form.setFields([{
      name: namePath,
      value: value,
      errors: []
    }]);
  }

  var transformChildren = function transformChildren() {
    if (Array.isArray(children)) {
      return children.flat().map(function (c, index) {
        var _c$type;

        if (['Igloo_Free_Form_Item', 'Igloo_Free_Form_Section', 'Igloo_Free_Form_AddableSection'].includes(c === null || c === void 0 ? void 0 : (_c$type = c.type) === null || _c$type === void 0 ? void 0 : _c$type.displayName)) {
          return /*#__PURE__*/cloneElement(c, _objectSpread(_objectSpread({
            key: index
          }, c.props), {}, {
            parentName: namePath,
            setShowStepButton: setShowStepButton,
            preview: preview,
            disabledFromParent: elementProps.disabled || disabledFromParent
          }));
        }

        return c;
      });
    }

    return /*#__PURE__*/isValidElement(children) ? /*#__PURE__*/cloneElement(children, _objectSpread(_objectSpread({}, children.props), {}, {
      parentName: namePath,
      setShowStepButton: setShowStepButton,
      preview: preview,
      disabledFromParent: elementProps.disabled
    })) : children;
  };

  return display ? _jsxs(_Col, {
    span: 24,
    className: 'igloo-freeform-section',
    style: style,
    children: [label && _jsx(Typography, _objectSpread(_objectSpread({
      className: 'igloo-freeform-section-label'
    }, labelProps), {}, {
      level: "h4",
      wrapElement: "div",
      children: label
    })), _jsx("div", _objectSpread(_objectSpread({
      className: 'igloo-freeform-section-content'
    }, contentProps), {}, {
      children: _jsx(_Row, {
        gutter: [32, preview ? 16 : 24],
        children: transformChildren()
      })
    }))]
  }) : null;
};

Section.displayName = 'Igloo_Free_Form_Section';
export default Section;